import {LoggerAppenderConfig} from '../logger-appender-config';
import {LogLevel} from '../../log-level';

/**
 * LocalStorage appender config
 */
export class LocalStorageAppenderConfig extends LoggerAppenderConfig {
  /**
   * Log Message Level that triggers processing.
   */
  triggerLevel: LogLevel = LogLevel.Error;

  /**
   * Number of previous log messages processed as context.
   */
  contextSize = 20;

  /**
   * Number of messages to store in localStorage
   * @type {number}
   */
  size: number = 20;

  /**
   * Key for localStorage to store messages
   * @type {string}
   */
  localStorageKey: string = 'hoteza.logger.messages';
}
